<template>
  <v-container>
    <v-btn class="ml-8" color="secondary" to="/admin/kegiatan/list">
      <v-icon left> mdi-arrow-left </v-icon>
      Kembali
    </v-btn>
    <form class="pa-4">
      <v-card flat outlined class="ma-4">
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                outlined
                v-model.trim="$v.kegiatan.name.$model"
                label="Nama Kegiatan"
                :error-messages="nameError"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                v-model.trim="$v.kegiatan.description.$model"
                label="Deskripsi"
                :error-messages="descriptionError"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-0" no-gutters>
            <v-col>
              <v-select
                :items="['routine', 'eventual']"
                outlined
                v-model.trim="$v.kegiatan.type.$model"
                label="Jenis Kegiatan"
                :error-messages="typeError"
              ></v-select>
            </v-col>
            <v-col v-if="kegiatan.type == 'routine'" class="ml-6">
              <v-select
                :items="[
                  'Senin',
                  'Selasa',
                  'Selasa',
                  'Rabu',
                  'Kamis',
                  'Jumat',
                  'Sabtu',
                  'Minggu',
                ]"
                outlined
                v-model.trim="$v.kegiatan.day.$model"
                label="Hari Kegiatan"
                :error-messages="dayError"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="mt-0" no-gutters>
            <v-col class="mr-6">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="
                      !kegiatan.start_date
                        ? ''
                        : formatDate(kegiatan.start_date)
                    "
                    outlined
                    clearable
                    label="Tanggal Mulai"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="kegiatan.start_date = null"
                    :error-messages="startDateError"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model.trim="$v.kegiatan.start_date.$model"
                  no-title
                  @change="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="
                      !kegiatan.end_date ? '' : formatDate(kegiatan.end_date)
                    "
                    outlined
                    clearable
                    label="Tanggal Berakhir"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="kegiatan.end_date = null"
                    :error-messages="endDateError"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model.trim="$v.kegiatan.end_date.$model"
                  no-title
                  @change="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row class="mt-0" no-gutters>
            <v-col class="mr-6">
              <v-text-field
                outlined
                v-model="kegiatan.start_time"
                label="Dimulai Pukul"
                type="time"
                :error-messages="startTimeError"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                v-model="kegiatan.end_time"
                label="Berakhir Pukul"
                type="time"
                :error-messages="endTimeError"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-0" no-gutters>
            <v-col class="mr-6">
              <v-text-field
                outlined
                v-model="kegiatan.additional_info.pembicara"
                label="Pembicara"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                v-model.trim="$v.kegiatan.location.$model"
                label="Lokasi"
                :error-messages="locationError"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-0" no-gutters>
            <v-col class="mr-6">
              <v-text-field
                outlined
                v-model="kegiatan.link"
                label="Link Kegiatan"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-file-input
                v-model="file"
                accept="image/*"
                label="Foto Kegiatan"
                filled
                prepend-icon="mdi-camera"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-btn @click="submit" color="primary" class="ml-4">
        Submit!
        <v-progress-circular
          v-if="this.isSubmitLoading == true"
          class="ml-2"
          indeterminate
          color="secondary"
          size="16"
          width="2"
        ></v-progress-circular>
      </v-btn>
      <v-dialog v-model="dialog" max-width="290">
        <v-card>
          <v-card-title class="headline"> Info </v-card-title>

          <v-card-text> Submit sukses! </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="dialog = false"
              to="/admin/kegiatan/list"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <p v-if="isFormError" class="mt-2 red--text text-caption error-caption">
        "Manusia memang sering melakukan kesalahan, tapi yang terpenting adalah
        bagaimana kita memperbaikinya" <br />
        -Admin
      </p>
    </form>
  </v-container>
</template>
<script>
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      file: null,
      menu2: false,
      menu: false,
      dialog: false,
      kegiatan: {
        masjid_uid: localStorage.getItem("masjid"),
        name: "",
        description: "",
        link: "",
        location: "",
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: "",
        day: "",
        type: "",
        additional_info: {},
      },
      isSubmitLoading: false,
      detailsKegiatan: {},
      isFormError: false,
    };
  },
  validations() {
    if(this.kegiatan.type == "routine") {
      return {
        kegiatan: {
          name: {
            required,
          },
          description: {
            required,
          },
          location: {
            required,
          },
          type: {
            required,
          },
          start_time: {
            required,
          },
          end_time: {
            required
          },
          day: {
            required
          },
          start_date: {
            required
          },
          end_date: {
            required
          }
        },
      }
    }else{
      return {
        kegiatan: {
          name: {
            required,
          },
          description: {
            required,
          },
          location: {
            required,
          },
          type: {
            required,
          },
          start_time: {
            required,
          },
          end_time: {
            required
          },
          start_date: {
            required
          },
          end_date: {
            required
          }
        },
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.fetchDetails();
    }
  },
  computed: {
    kegiatanDetails() {
      return this.detailsKegiatan;
    },
    nameError() {
      const errors = [];
      if (!this.$v.kegiatan.name.$dirty) return errors;
      !this.$v.kegiatan.name.required &&
        errors.push("Nama kegiatan tidak boleh kosong");
      return errors;
    },
    descriptionError() {
      const errors = [];
      if (!this.$v.kegiatan.description.$dirty) return errors;
      !this.$v.kegiatan.description.required &&
        errors.push("Deskripsi kegiatan tidak boleh kosong");
      return errors;
    },
    locationError() {
      const errors = [];
      if (!this.$v.kegiatan.location.$dirty) return errors;
      !this.$v.kegiatan.location.required &&
        errors.push("Lokasi kegiatan tidak boleh kosong");
      return errors;
    },
    typeError() {
      const errors = [];
      if (!this.$v.kegiatan.type.$dirty) return errors;
      !this.$v.kegiatan.type.required &&
        errors.push("Tipe kegiatan tidak boleh kosong");
      return errors;
    },
    startTimeError() {
      const errors = [];
      if (!this.$v.kegiatan.start_time.$dirty) return errors;
      !this.$v.kegiatan.start_time.required &&
        errors.push("Waktu mulai tidak boleh kosong");
      return errors;
    },
    endTimeError() {
      const errors = [];
      if (!this.$v.kegiatan.end_time.$dirty) return errors;
      !this.$v.kegiatan.end_time.required &&
        errors.push("Waktu berakhir tidak boleh kosong");
      return errors;
    },
    dayError() {
      const errors = [];
      if(this.kegiatan.type == "routine") {
        if (!this.$v.kegiatan.day.$dirty) return errors;
        !this.$v.kegiatan.day.required && 
        errors.push("Hari tidak boleh kosong");
      }
      return errors;
    },
    startDateError() {
      const errors = [];
      if (!this.$v.kegiatan.start_date.$dirty) return errors;
      !this.$v.kegiatan.start_date.required &&
        errors.push("Tanggal mulai tidak boleh kosong");
      return errors;
    },
    endDateError() {
      const errors = [];
      if (!this.$v.kegiatan.end_date.$dirty) return errors;
      !this.$v.kegiatan.end_date.required &&
        errors.push("Tanggal berakhir tidak boleh kosong");
      return errors;
    },
  },
  watch: {
    kegiatanDetails() {
      (this.kegiatan.name = this.kegiatanDetails.name),
        (this.kegiatan.description = this.kegiatanDetails.description),
        (this.kegiatan.link = this.kegiatanDetails.link),
        (this.kegiatan.location = this.kegiatanDetails.location),
        (this.kegiatan.start_date = this.kegiatanDetails.start_date),
        (this.kegiatan.end_date = this.kegiatanDetails.end_date),
        (this.kegiatan.start_time = this.kegiatanDetails.start_time),
        (this.kegiatan.end_time = this.kegiatanDetails.end_time),
        (this.kegiatan.day = this.kegiatanDetails.day),
        (this.kegiatan.type = this.kegiatanDetails.type),
        (this.kegiatan.additional_info = this.kegiatanDetails.additional_info);
    },
  },
  methods: {
    fetchDetails() {
      this.axios(`/program/detail/${this.$route.params.id}`)
        .then((res) => {
          console.log(res, "response fetch details program");
          if (res.data.status == true) {
            this.detailsKegiatan = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err, "error fetch details program");
        });
    },
    submit() {
      this.isSubmitLoading = true;
      this.$v.$touch();
      if (this.$v.kegiatan.$invalid) {
        this.isFormError = true;
        this.isSubmitLoading = false;
      } else {
        if (this.$route.params.id) {
          let program_uid = this.$route.params.id;
          let masjid_uid = this.kegiatan.masjid_uid;

          this.axios
            .post(`/program/update/${program_uid}`, this.kegiatan)
            .then((res) => {
              console.log(res, "response update kegiatan");

              if (res.data.status == true) {
                if (this.file != null) {
                  let formData = new FormData();
                  formData.append("file", this.file);
                  return this.axios.post(
                    `/program/image/${masjid_uid}/${program_uid}`,
                    formData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                  );
                }
              }
            })
            .then((res) => {
              this.isFormError = false
              this.dialog = true;
              this.isSubmitLoading = false;
              console.log(res, "res upload image kegiatan");
            })
            .catch((err) => {
              this.isSubmitLoading = false;
              console.log(err, "error submit laporan");
            });
        } else {
          this.axios
            .post("/program", {
              masjid_uid: this.kegiatan.masjid_uid,
              name: this.kegiatan.name,
              description: this.kegiatan.description,
              link: this.kegiatan.link,
              location: this.kegiatan.location,
              start_date: this.kegiatan.start_date,
              end_date: this.kegiatan.end_date,
              start_time: this.kegiatan.start_time,
              end_time: this.kegiatan.end_time,
              day: this.kegiatan.day,
              type: this.kegiatan.type.toLowerCase(),
              additional_info: this.kegiatan.additional_info,
            })
            .then((res) => {
              console.log(res, "response submit kegiatan");

              let masjid_uid = this.kegiatan.masjid_uid;
              let program_uid = res.data.data.masjid_program_uid;

              if (res.data.status == true) {
                if (this.file != null) {
                  let formData = new FormData();
                  formData.append("file", this.file);
                  return this.axios.post(
                    `/program/image/${masjid_uid}/${program_uid}`,
                    formData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                  );
                }
              }
            })
            .then((res) => {
              this.isFormError = false
              this.dialog = true;
              this.isSubmitLoading = false;
              console.log(res, "res upload image kegiatan");
            })
            .catch((err) => {
              this.isSubmitLoading = false;
              console.log(err, "error submit laporan");
            });
        }
      }
    },
    formatDate(date) {
      return this.$moment(date).format("D MMMM YYYY");
    },
  },
};
</script>
